<template>

    <div
        :class="['filter-dialog', size, align]"
        v-click-outside="(ev) => dismiss(ev, name)">
            <slot>...</slot>
    </div>
    <!-- v-show="open" -->
</template>

<script>

import { mapState, mapGetters } from 'vuex';

export default {

    props: {
        // open: Boolean,
        size: String,
        align: String,
        name: String,
    },

    computed: {
        ...mapState([
            'focus',
        ]),
        ...mapGetters([
            'moreOpened',
        ]),
    },

    methods: {
        dismiss(ev, filter) {
            if (this.focus === filter) {
                this.$store.dispatch('toggleFilter');
            }
        },
    },
};
</script>


<style lang="scss">

    @import "@/common/scss/_variables.scss";
    @import "@/common/scss/_mixins.scss";

    .filter-dialog {

        background: white;
        color: #333;
        box-shadow: 5px 5px 5px 0px rgba(0,0,0,0.05);

        position: absolute;
        z-index: 2000;
        top: 100%;

        @include media-breakpoint-down(sm) {
            width: auto;
            left: 0;
            right: 0;
            padding: 20px;
            border: 1px solid $lighter;
        }

        @include media-breakpoint-up(md) {
            width: 240px;
            padding: 20px;
            margin-top: 3px;
        }

        @include media-breakpoint-up(md) {
            &.right { right: 0; }
            &.wide { width: 660px; }
            &.medium { width: 330px; }
            &.auto { width: auto; }
        }

        .filter-sort & {
            width: 240px;
            padding: 20px;
            margin-top: 3px;
            left: auto;
            border: none;
        }


        .filter-content {

            &.filter-minmax {

                display: flex;
                // flex-flow: column nowrap;
                flex-flow: row nowrap;
                margin: -20px -20px;

                .filter-age & {
                    .filter-title, .list-group-item {
                        text-align: center;
                    }
                }

                @include media-breakpoint-up(md) {
                    margin: 0 -20px;
                }

                .filter-group {

                    flex-grow: 1;
                    flex-basis: 50%;

                    &:first-child {
                        border-right: 1px solid $light;
                    }

                    .filter-title {
                        border-bottom: 1px solid $lighter;
                    }

                    .list-group {
                        max-height: 375px;
                        overflow-y: auto;
                    }

                    @include media-breakpoint-up(md) {
                        margin: -20px 0;
                    }

                }
            }

            &.filter-multi {
                display: flex;
                flex-flow: column;

                @include media-breakpoint-up(md) {
                    flex-flow: column wrap;
                    max-height: 350px;
                }

                label {
                    font-size: 15px;
                }

                .custom-control {
                    flex-basis: auto;
                    width: 200px;
                }
            }

            &.filter-date {
                margin: -20px -20px 0 -20px;
            }

            &.filter-single {
                margin: -20px -20px;
            }

            .filter-title {
                padding: 10px 20px;
                font-size: 15px;
                text-transform: uppercase;
                font-weight: bold;
            }

            .filter-text-entry {
                padding: 10px 20px;
                font-size: 15px;
            }

            .list-group {

                .list-group-item {

                    padding: 10px 20px;
                    border: none;
                    text-transform: uppercase;
                    font-size: 15px;

                    &.active {

                    }

                    &.disabled {
                        color: $lighter;
                    }
                }
            }
        }

    }

</style>
